import {
  prefetchCustomerCompanyListQuery,
  useCustomerCompanyListSuspense,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import { PlusIcon } from "lucide-react"
import { useStore } from "zustand"

import { CompanyMiniCard } from "@/components/company/partners/CompanyMiniCard"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { store } from "@/lib/store"

export const Route = createFileRoute("/_dashboard/partners/companies/manage")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["customer.view_company"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await prefetchCustomerCompanyListQuery(queryClient)
  },
})

function RouteComponent() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)

  const { data: companies } = useCustomerCompanyListSuspense({
    ordering: "last_modified_at",
  })

  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>Your Companies</CardTitle>
        <Link to="/partners/companies/add">
          <Button variant="default">
            <PlusIcon />
            Add New Company
          </Button>
        </Link>
      </CardHeader>
      <CardContent>
        <div className="mt-8 flex flex-row flex-wrap gap-5">
          {companies?.map((company) => (
            <CompanyMiniCard
              key={company.uuid}
              company={company}
              isSelected={company.uuid === activeCompanyUuid}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
